






















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class TableActionButton extends Vue {
  @Prop({ required: true }) icon: string;

  @Prop({ required: true }) tooltip: string;

  @Prop({ type: Boolean, default: false }) readonly xSmall: boolean;

  @Prop({ type: Boolean, default: false }) readonly disabled: boolean;
}
